var $export = require('./_export');

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: require('./_string-repeat')
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/es6.string.repeat.js
 ** module id = 1260
 ** module chunks = 1
 **/